<template>
  <v-row>
    <v-col cols="12" md="2">
      <v-text-field :model-value="searchInputValue" @update:model-value="onSearchInput" density="compact"
        prepend-icon="mdi-magnify" label="Rechercher" hide-details></v-text-field>
    </v-col>
    <v-col cols="12" md="2" v-if="mode == 'admin'">
      <v-select :model-value="modelValue.search_by" @update:model-value="updateParams({ search_by: $event })"
        :items="$itemsSelect.inscriptions_search_by()" hide-details item-title="title" item-value="value"
        label="Recherche par" density="compact"></v-select>
    </v-col>
    <v-col cols="12" md="2" v-if="courseSelect && !billetterieMode">
      <v-select :model-value="modelValue.id_course" @update:model-value="updateParams({ id_course: $event })"
        :items="courseSelect" hide-details item-title="text" item-value="value" label="Parcours"
        density="compact"></v-select>
    </v-col>
    <v-col cols="12" md="2" v-if="!billetterieMode">
      <v-select :model-value="modelValue.order_by" @update:model-value="updateParams({ order_by: $event })"
        :items="$itemsSelect.order_by_select(mode == 'admin')" hide-details item-title="title" item-value="value"
        label="Trier par" density="compact"></v-select>
    </v-col>
    <v-col cols="12" md="2" class="d-flex align-center">
      <v-btn class="rounded-0 rounded-s" :variant="modelValue.sexe == '' ? 'elevated' : 'outlined'" elevation="0"
        color="primary-dark" @click="updateParams({ sexe: '' })">
        <v-icon icon="mdi-human-male-female"></v-icon>
      </v-btn>
      <v-btn class="rounded-0" :variant="modelValue.sexe == 'M' ? 'elevated' : 'outlined'" elevation="0"
        color="primary-dark" @click="updateParams({ sexe: 'M' })">
        <v-icon icon="mdi-human-male"></v-icon>
      </v-btn>
      <v-btn class="rounded-0 rounded-e" :variant="modelValue.sexe == 'F' ? 'elevated' : 'outlined'" elevation="0"
        color="primary-dark" @click="updateParams({ sexe: 'F' })">
        <v-icon icon="mdi-human-female"></v-icon>
      </v-btn>
    </v-col>
    <v-col cols="12" md="12" v-if="mode == 'admin'">
      <v-checkbox :model-value="modelValue.hide_deleted" @update:model-value="updateParams({ hide_deleted: $event })"
        density="compact" label="Masquer les inscriptions supprimées/vendues/transférées"></v-checkbox>
    </v-col>
  </v-row>
</template>

<script>
const DEBOUNCE_MS = 300;

export default {
  props: {
    modelValue: {
      type: Object,
      required: true,
    },
    mode: {
      type: String,
      default: "",
    },
    courseSelect: {
      type: Array,
      default: () => [],
    },
    billetterieMode: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      searchInputValue: "",
      searchDebounceTimer: null,
    };
  },
  watch: {
    "modelValue.search_value": {
      handler(val) {
        this.searchInputValue = val || "";
      },
      immediate: true,
    },
  },
  methods: {
    onSearchInput(value) {
      this.searchInputValue = value;
      if (this.searchDebounceTimer) clearTimeout(this.searchDebounceTimer);
      this.searchDebounceTimer = setTimeout(() => {
        this.updateParams({ search_value: value });
      }, DEBOUNCE_MS);
    },
    updateParams(updates) {
      this.$emit("update:modelValue", { ...this.modelValue, ...updates });
    },
  },
};
</script>
